import apiClient from './client';

export const templatesApi = {
  getAll: (params) => apiClient.get('/api/templates', { params }),

  getById: (id) => apiClient.get(`/api/templates/${id}`),

  create: (data) => apiClient.post('/api/templates', data),

  update: (id, data) => apiClient.put(`/api/templates/${id}`, data),

  delete: (id) => apiClient.delete(`/api/templates/${id}`),

  getStatus: (params) => apiClient.get('/api/templates/status', { params }),

  getDrafts: (params) => apiClient.get('/api/templates/drafts', { params }),

  saveDraft: (data) => apiClient.post('/api/templates/drafts', data),

  updateDraft: (id, data) => apiClient.put(`/api/templates/drafts/${id}`, data),

  deleteDraft: (id) => apiClient.delete(`/api/templates/drafts/${id}`),

  submit: (id) => apiClient.post(`/api/templates/${id}/submit`),

  preview: (data) => apiClient.post('/api/templates/preview', data),

  getCategories: () => apiClient.get('/api/templates/categories'),

  getLanguages: () => apiClient.get('/api/templates/languages'),

  getApproved: (params) => apiClient.get('/api/templates/approved', { params }),

  sync: (id) => apiClient.post(`/api/templates/${id}/sync`),
};

export default templatesApi;
